import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserContextService {
  private readonly SESSION_KEY = 'mygooru-ai-mobile-user-session';
  private contactSubject = new BehaviorSubject<{
    contact: string;
    contactType: 'phone' | 'email';
    countryDialingCode?: string;
    countryCode?: string;
  } | null>(null);
  public contact$ = this.contactSubject.asObservable();

  /**
   * @function sendOtp
   * validateForm method used to send OTP
   */
  public setContact(contact: {
    contact: string;
    contactType: 'phone' | 'email' | 'external';
    countryDialingCode?: string;
    countryCode?: string;
    loginType?: string;
    first_name?: string;
    role?: string;
    user_id?: string
  }) {
    localStorage.setItem(this.SESSION_KEY, JSON.stringify(contact));
  }

  /**
   * @function getContact
   * validateForm method used to get session details
   */
  public getContact() {
    const session = localStorage.getItem(this.SESSION_KEY);
    return session ? JSON.parse(session) : null;
  }

  /**
   * @function isAuthenticated
   * validateForm method used to check authentication
   */
  public isAuthenticated() {
    const session = this.getContact();
    return session && session['contact']?.length;
  }

  /**
   * @function clearContact
   * validateForm method used to clear session
   */
  public clearContact() {
    localStorage.removeItem(this.SESSION_KEY);
  }
}
